import { Atom,Commet,Riple } from "react-loading-indicators";
/* 
| OR directly pull it 😎
| import Atom from "react-loading-indicators/Atom";
*/

export const AtomLoading = ({text}) => <Atom size="large" speedPlus={-3}/>;
export const CommetLoading = ({text}) => <Commet size="large"/>;
export const RippleLoading = ({text}) => <Riple size="large"/>;